import React from 'react';
import { Navigate } from 'react-router-dom';
import { shouldShowPage, canAccessPage, NoAccessMessage, isGuestUser } from '../utils/permissionControl';

/** 自 App.js 原样迁出，行为不变 */
// 路由守卫组件 - 支持访客和访问控制逻辑
function ProtectedRoute({ children, perm, allowGuest = false }) {
  const token = localStorage.getItem('token') || '';
  const isGuest = isGuestUser();

  // 未登录：allowGuest 页面直接放行（工具下载/坐标转换等）
  if (isGuest) {
    if (allowGuest || canAccessPage(perm)) {
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  // 已登录但无 token 异常时，按需跳转登录
  if (!token && !allowGuest) {
    return <Navigate to="/login" replace />;
  }

  // 检查页面是否应该显示
  if (!shouldShowPage(perm)) {
    return <Navigate to="/" replace />;
  }

  // 检查用户是否可以访问页面内容
  if (!canAccessPage(perm)) {
    return <NoAccessMessage permissionName={perm} />;
  }

  return children;
}

export default ProtectedRoute;
